export const insertAfterIndex = <T>(
    newItem: T,
    index: number,
    array: Array<T>,
): Array<T> =>
    array.reduce((result, item, i) => {
        result.push(item);
        if (i === index) {
            result.push(newItem);
        }
        return result;
    }, [] as Array<T>);

export const insertBeforeIndex = <T>(
    newItem: T,
    index: number,
    array: Array<T>,
): Array<T> =>
    array.reduce((result, item, i) => {
        if (i === index) {
            result.push(newItem);
        }
        result.push(item);
        return result;
    }, [] as Array<T>);

export const isEmpty = <T>(array: Array<T>): boolean =>
    array == null || array.length === 0;
